
import React, { useContext, useEffect, useState, useRef } from 'react';
import { AuthContext } from '../../authentication/Auth';
import app from '../../authentication/firebaseStart';
import LocationIcon from '@material-ui/icons/LocationOn';
import styled from "styled-components";
import {
  PageTitle, SnackbarContent,
} from "../../styled-components/shared";
import GoBack from '../../components/GoBack'
import { CircularProgress, Grid, Paper, Snackbar, IconButton } from '@material-ui/core';
import AddNoteModal from '../../components/modals/AddNoteModal';
import { DataContext } from '../../data/DataContext';
import { useHistory } from "react-router";
import ActionDropDown from "../../components/ActionDropDown";
import ModifyDevicesPopUp from "../../components/modals/ModifyDevicesPopUp";
import firebaseUtil from '../../data/FirebaseUtil';
import { useTranslation } from 'react-i18next';
// import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import ChangeActionTbf from '../../components/modals/ChangeActionTbf';
import InfoModal from '../../components/modals/InfoModal';
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import { DLR_MACHINE_LEARNING } from '../../data/constants';
import { launchMap } from "../../data/gpsUtil";
import EditIcon from '@material-ui/icons/Edit';
import TextField from '@material-ui/core/TextField';
import { convertUtcToTimeZone } from '../../data/dateTimeUtil';
import TooltipMat from '../../components/TooltipMat';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { DEVICELIST_CONSTANT } from "../../data/constants";
import { getSite } from '../../utils/SiteSession';
const firestore = app.firestore();

const KeyNameBold = styled.p`
  font-weight: 600;
  margin: 0px;
`;

const DetailsCard = styled(Paper)`
  margin-top: 1%;
  padding: 15px;
  border: 1px solid #bdbdbd;
`;

const BacknTitle = styled.div`
  display: flex;
  align-items: center;
  margin-top: -20px;
`;

const MainContent = styled.div`
  border-top: 2px solid #e1e1e1;
  borer-bottom: none;
  border: 1px solid #bdbdbd;
`;
const LocationSpan = styled.span`
    position:relative;
    bottom:8px
`;

const PageWrapper = styled.div`
    background: white;
    box-shadow: 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%), 0 1px 3px 0 rgb(0 0 0 / 20%);
    padding: 20px;
`;

const defaultReferalNum = {
  1: {
    "deviceState": "To Be Found"
  },
  0: {
    "deviceState": "In Service"
  },
  2: {
    "deviceState": "Being Found"
  },
  3: {
    "deviceState": "Found"
  },
  4: {
    "deviceState": "Cannot Find"
  },
  5: {
    "deviceState": "At Risk"
  },
  9999: {
    "deviceState": "Decommissioned"
  }
}


function DeviceDetails(props) {

  const history = useHistory();
  const { tableData = {} } = props;
  const context = useContext(AuthContext);
  let { currentUserObj } = useContext(DataContext);
  // DLR flag
  const { dlrFeatureFlag, mlPredictionStatus } = useContext(DataContext);
  const [showDLR, setShowDLR] = useState(false);
  const DEFAULT_ROWS_PER_PAGE = 10;
  // const [pageSize, setPageSize] = useState(DEFAULT_ROWS_PER_PAGE);
  const [isLoading, setIsLoading] = useState(false)
  let { globalAppSettings } = useContext(DataContext);

  const addUserModalRef = useRef();
  const tbfRef = useRef();
  const infoModalRef = useRef();
  const [selectedRowData, setSelectedRowData] = useState({})
  const [selectedRowStatus, setSelectedRowStatus] = useState(null)
  const [currDeviceState, setCurrDeviceState] = useState(null)
  const [currCheckOut, setCurrCheckOut] = useState(null)
  const [actionVal, setActionVal] = useState([])
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const serverResponse = useRef("");
  const { t } = useTranslation()
  const [soundPlayed, setSoundPlayed] = useState(false)
  const [gpsLocationCollectionEnabled, setGpsLocationCollectionEnabled] = useState(true);
  const [addNoteValue, setAddNoteValue] = useState("");
  const [addDeviceName, setaddDeviceName] = useState("");
  const [deviceNameError, deviceNameSetError] = useState(false); // deviceNameError
  // const [deviceTimeZone , setDeviceTimeZone] = useState(selectedRowData.siteTimeZone)
  const [btscannerState, setBTScannerState] = useState(0);
  console.log(selectedRowData, 114);

  const dataForExcept9999 = [
    'friendlyName',
    'serialNumber',
    'modelNumber',
    'apFriendlyName',
    'btscanner',
    'gpsLocation',
    'deviceState',
    'batteryLevel',
    'isCharging',
    'displaySiteName',
    'note',
    'licenseState',
    'reportedAt',
    'connectionState',
    'secondaryBleInfo',
    'screenOn',
    'isIdle',
    'displayUserId',
    'siteTimeZone'
  ]

  const dataFor9999 = [
    'friendlyName',
    'serialNumber',
    'modelNumber',
    // 'apFriendlyName',
    'deviceState',
    // 'displaySiteName',
    'note',
    'licenseState',
    // 'reportedAt',
    'secondaryBleInfo'
    // 'screenOn',
    // 'isIdle',
    // 'displayUserId'
  ]

  const [keysToFilter, setKeysToFilter] = useState(dataForExcept9999)



  const [KeyNameMapper] = useState({
    friendlyName: t('deviceDetail.deviceName'),
    serialNumber: t('deviceDetail.serialNumber'),
    modelNumber: t('deviceDetail.modelNumber'),
    apFriendlyName: t('deviceDetail.apFriendlyName'),
    btscanner: (<>Accessory &nbsp;
      <TooltipMat
        title={(<><p style={{
          color: "#6EF0B8",
          fontSize: 16,
          fontWeight: 400
        }}>
          Green: Connected
        </p>
          <p style={{
            color: "#FF8692",
            fontSize: 16,
            fontWeight: 400
          }}>
            Red: Disconnected
          </p>
          <p style={{
            color: "#FFFFFF",
            fontSize: 16,
            fontWeight: 400
          }}>Black: Last Connected
          </p></>)
        }
        data={(<HelpOutlineIcon style={{ fontSize: 16 }} />)}
      />
    </>),
    gpsLocation: t('deviceDetail.gpsLocation'),
    gpsReportAt: t('deviceDetail.gpsReportAt'),
    deviceState: t('deviceDetail.status'),
    isCharging: t('deviceDetail.isCharging'),
    displaySiteName: t('deviceDetail.displaySiteName'),
    note: t('deviceDetail.note'),
    licenseState: t('deviceDetail.licenseState'),
    reportedAt: t('deviceDetail.reportedAt'),
    connectionState: t('deviceDetail.connectionState'),
    secondaryBleInfo: t('deviceDetail.secondaryBleInfo'),
    batteryLevel: t('deviceDetail.batteryLevel'),
    screenOn: t('deviceDetail.screenOn'),
    isIdle: t('deviceDetail.isIdle'),
    displayUserId: t('deviceDetail.displayUserId'),
    dlrEnrolStatus: t('deviceDetail.dlrEnrolStatus'),
    lastEnrolOn: t('deviceDetail.lastEnrolOn'),
    dlrIssue: t('deviceDetail.dlrIssue')
  })
  const [deviceStatusColorMapper] = useState({
    "In Service": "#7A7A7A",
    "At Risk": "#FF2E00",
    "To Be Found": "#FF2E00",
    "Being Found": "#007CB0",
    "Found": "#00B400",
    "Cannot Find": "#FF2E00",
    "Decommissioned": "#7A7A7A"
  })

  const [accessoryStateColorMap] = useState({
    0: "#1D1E23",
    1: "#00864F",
    2: "#D70015"

  })
  const [clearNote, setClearNote] = useState(false)
  const [note, setNote] = useState("")
  const [currentAction, setCurrentAction] = useState("")
  const [currFireObj, setCurrFireObj] = useState({})
  const [foundAutomation, setFoundAutomation] = useState(false)
  const [infoModalMsg, setInfoModalMsg] = useState("")

  const [SData, setSData] = useState('')
  const ModifyDevicesModalRef = useRef();
  const [modifyDevicesPopupData, setmodifyDevicesPopupData] = useState({})
  const confirmationModalRef = useRef();
  const [confirmPopData, setconfirmPopData] = useState([]);

  useEffect(() => {
    if (!dlrFeatureFlag) {
      // hiding At Risk if dlr feature is disabled
      setShowDLR(false);
    }
    else {
      if (mlPredictionStatus) setShowDLR(true);     // showing At Risk if ml prediction enabled
      else setShowDLR(false);                      // hiding At Risk if ml prediction disabled
    }
  }, [mlPredictionStatus, dlrFeatureFlag]);

  useEffect(() => {
    // uncomment below lines once decided to to fixed on enrolment column

    // if(showDLR){
    //   if(keysToFilter.indexOf("dlrEnrolStatus") == -1){
    //     keysToFilter.push('dlrEnrolStatus')
    //     keysToFilter.push('lastEnrolOn')
    //     keysToFilter.push('dlrIssue')
    //   }
    // }
    // else{
    if (keysToFilter.indexOf("dlrEnrolStatus") > -1) {
      keysToFilter.splice(keysToFilter.indexOf("dlrEnrolStatus"), 1)
      keysToFilter.splice(keysToFilter.indexOf("lastEnrolOn"), 1)
      keysToFilter.splice(keysToFilter.indexOf("dlrIssue"), 1)
    }
    // }
  }, [showDLR])

  useEffect(() => {
    setSelectedRowStatus(history?.location?.state?.tableData?.deviceState)
    let docId = `${history?.location?.state?.tableData.modelNumber}_${history?.location?.state?.tableData.serialNumber}`;
    //let docId = 'TC70X_17006522509539';
    setIsLoading(true)
    getData(docId)
    document.title = t('deviceTracker') + " " + t("deviceDetails");
    // setdropdown()
    settingsData();
  }, []);


  useEffect(() => {
    if (Object.keys(globalAppSettings).length > 0) {
      setDbToLocal();
      setIsLoading(false);
    } else {
      setTimeout(() => {
        setIsLoading(false)
      }, 1000)
    }
  }, [globalAppSettings])

  const setDbToLocal = () => {
    let toBe = globalAppSettings.workFlowData
    toBe?.enableFoundAutomation && setFoundAutomation(toBe?.enableFoundAutomation)
  }
  useEffect(() => {
    if (currFireObj) {
      if (Object.keys(currFireObj)?.length > 0 && Object.keys(globalAppSettings)?.length > 0) {
        destrcutureData();
      }
    }
  }, [currFireObj, globalAppSettings])

  useEffect(() => {
    setdropdown()
    //     setActionVal(newArr)
  }, [currDeviceState, currCheckOut, globalAppSettings])

  /*
   * Change to Inservice if Automatically place device “In Service” when marked “Found” is CHEDKED
   * ZD 233   
  */
  useEffect(() => {
    /* console.log(foundAutomation,'mdv foundAutomation')
    console.log(typeof currDeviceState,'mdv typeof currDeviceState')
    if(foundAutomation && (currDeviceState === 3)) {
      console.log(currDeviceState,'mdv currDeviceState')
      updateDeviceState();
    } */

    settingsData();
  }, [currDeviceState, foundAutomation]);

  async function settingsData() {
    //
    let companyID = context.currentUser.claims.companyID;
    const settingsRef = firestore
      .collection('tenants')
      .doc(companyID)
      .collection('Configuration')
      .doc('AppSettings')

    settingsRef.onSnapshot((querySnapshot) => {
      var items = {};
      items = querySnapshot.data();
      if (items.enableFoundAutomation && (currDeviceState === 3)) {
        updateDeviceState();
      }
    })
    //
  }

  async function updateDeviceState() {
    let companyID = context.currentUser.claims.companyID;
    /* 0 - Inservice value */
    let value = 0;
    let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
    let deviceData = { deviceState: value, deviceStateUpdatedBy: 0 }

    let batch = firestore.batch()
    const monitorDocRef = firestore.collection("tenants")
      .doc(companyID)
      .collection('Devices')
      .doc(docId)
      .collection('Monitor')
      .doc('DeviceState')

    batch.update(monitorDocRef, deviceData)

    const docRef = firestore.collection("tenants")
      .doc(companyID)
      .collection('Devices')
      .doc(docId)

    batch.update(docRef, deviceData)
    await batch.commit();

  }

  const setdropdown = () => {
    let actionsValue =
      [
        { label: "Refresh Current Device's Location", disable: false, action: 't' },
        { label: 'Mark Device for finding', disable: false, action: 't' },
        { label: 'Mark device as InService', disable: false, action: 't' },
        { label: 'Play Sound', disable: false, action: 't' },
        { label: 'Add Notes', disable: false, action: 't' },
        { label: 'Recommission Device', disable: false, action: 't' },
        { label: 'Decommission Device', disable: false, action: 't' },
        { label: 'Start finding', disable: false, action: 't' },
      ]




    // let actionsValue = [];
    actionsValue.push({ label: 'Edit', disable: false, header: true });
    // Device Delete 
    if (!isManager) {
      //Update site is availabe only for ADMIN
      actionsValue.push({ label: 'Delete Device', key: 'delete', disable: false, action: 'd' });
    }

    // if (actionsValue.length == 1) {
    //   //There is only one item on actionMenus. i.e) only EDIT main is available
    //   //So no point in showing only that without sub items. Delete that
    //   actionsValue.splice(0, 1);
    // }

    //Other Menus
    actionsValue.push({ label: 'Tracking', disable: false, header: true });

    let enableList = [
      {
        "value": 0,
        "list": [
          "Edit",
          "Delete Device",
          "Tracking",
          "Refresh Current Device's Location",
          "Mark Device for finding",
          "Decommission Device",
          "Play Sound",
        ],
        "notAllowed": [
          "Recommission Device",
          "Mark device as InService"
        ]
      },
      {
        "value": 1,
        "list": [
          "Edit",
          //"Site",
          // "Access Point Friendly Name",
          //"Device Name",
          "Delete Device",
          "Tracking",
          "Refresh Current Device's Location",
          "Decommission Device",
          "Play Sound",
          // "Add Notes",
          "Start finding",
          "Mark device as InService"
        ],
        "notAllowed": [
          "Recommission Device",
          "Mark Device for finding"
        ]
      },
      {
        "value": 2,
        "list": [
          "Edit",
          //"Site",
          // "Access Point Friendly Name",
          //"Device Name",
          "Delete Device",
          "Tracking",
          "Refresh Current Device's Location",
          "Decommission Device",
          "Play Sound",
          // "Add Notes",
          "Mark device as InService"
        ],
        "notAllowed": [
          "Recommission Device",
          "Mark Device for finding"
        ]
      },
      {
        "value": 3,
        "list": [
          "Edit",
          "Delete Device",
          "Tracking",
          "Refresh Current Device's Location",
          "Decommission Device",
          "Mark Device for finding",
          "Mark device as InService",
          "Play Sound"
        ],
        "notAllowed": [
          "Start finding",
          "Recommission Device"
        ]
      },
      {
        "value": 4,
        "list": [
          "Edit",
          //"Site",
          // "Access Point Friendly Name",
          //"Device Name",
          "Delete Device",
          "Tracking",
          "Refresh Current Device's Location",
          "Mark device as InService",
          "Decommission Device",
          "Mark Device for finding",
          "Play Sound"
        ],
        "notAllowed": [
          "Start finding",
          "Recommission Device"
        ]
      },
      {
        "value": 5,
        "list": [
          "Edit",
          "Site",
          // "Access Point Friendly Name",
          "Device Name",
          "Delete Device",
          "Tracking",
          "Decommission Device",
          "Add Notes",
          "Start finding",
          "Mark Device for finding",
          "Mark device as InService"
        ],
        "notAllowed": [
          "Recommission Device"
        ]
      },
      {
        "value": 9999,
        "list": [
          "Edit",
          //"Site",
          // "Access Point Friendly Name",
          //"Device Name",
          "Delete Device",
          "Tracking",
          "Refresh Current Device's Location",
          "Recommission Device",
          "Play Sound",
          // "Add Notes"
        ],
        "notAllowed": [
          "Start finding",
          "Mark device as InService",
          "Decommission Device",
          "Mark Device for finding",
        ]
      },
    ]



    var deviceState = currDeviceState;
    let newArr = []
    enableList.forEach(val => {
      if (val.value === deviceState) {
        val.list.forEach(aa => {
          actionsValue.forEach(vv => {
            if (vv.label === aa) {
              // { label: 'Tracking', disable: false, header: true }
              return newArr.push({
                label: vv.label,
                action: vv.action,
                disable: vv.action == 't' ? false : vv.disable,
                header: vv?.header ? vv?.header : false,
                key: vv.key ? vv.key : ''
              })
            }
          })
        })
        val.notAllowed.forEach(aa => {
          actionsValue.forEach(vv => {
            if (vv.label === aa && vv.action == 't') {
              return newArr.push({
                label: vv.label,
                action: vv.action,
                disable: vv.action == 't' ? true : vv.disable,
                header: vv?.header ? vv?.header : false,
                key: vv.key ? vv.key : ''
              })
            }
          })
        })
        return
      }
      return
    })
    setActionVal(newArr)
  }

  const getAddedNote = (value) => {
    let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
    setIsLoading(true)
    let data = { note: value }
    setClearNote(true)
    addData(data, docId, 'note',);
    // getData('TC52_21168522510451', 'MSRU1TVAwlhOlqKbpQT97BfgQmD3')

  }

  const getAddedDeviceName = (value) => {      // getDeviceName
    let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
    setIsLoading(true)
    let data = { displayDeviceFriendlyName: value, friendlyName: value.toUpperCase() }
    setClearNote(true)
    addData(data, docId, "friendlyName")
  }

  const AddModiDeletePopUpTrigger = (e) => {
    console.log(e, e?.needToLoad, 'e?.needToLoad')

    if (e?.msg?.show) {
      serverResponse.current = {
        status: !e.msg.error,
        msg: e.msg.data,
      };
      setSnackbarOpen(true);
    }
    if (e?.close) {
      if (e?.from == 'modify') { ModifyDevicesModalRef.current.toggleDialog(); }
    }
    if (e?.needToLoad) {
      console.log('camededed')
      // getData(pageSize, location)
    }
  }

  const fromConfirmationPopup = async (e) => {

    console.log(e, 'asddasd')

    if (e.btnData.scope == 'delete') {
      if (e.btnData.proceed) {
        // deleteDevices(e.checkAll)

        console.log(history, 'sdsdsd')
        // return
        try {
          let batch = firestore.batch();
          setIsLoading(true);
          // SData.forEach(element => {

          let docRef = firestore.collection("tenants")
            .doc(context.currentUser.claims.companyID)
            .collection('Devices')
            .doc(SData.modelNumber + '_' + SData.serialNumber);

          batch.delete(docRef)
          // });

          await batch.commit();

          setTimeout(() => {
            AddModiDeletePopUpTrigger({
              from: 'delete',
              msg: { show: true, error: false, data: `1 Devices Deleted Successfully` },
              needToLoad: true
            })
          }, 1000);
          // history.push({
          //   pathname: "/dashboard/deviceslist/mobile-devices",
          //   // state: {  },
          // });
          history.goBack()
        } catch (e) {
          setIsLoading(false);
          AddModiDeletePopUpTrigger({
            from: 'delete',
            msg: { show: true, error: true, data: 'Devices Deleting Failed' },
            needToLoad: false
          })
          console.log('ffdsd', e)
        }


      }
      confirmationModalRef.current.toggleDialog();
    }

  }

  const PerformEditAction = (e) => {

    console.log(SData, 'SData')

    console.log(e, 'hdghdgdgd')
    if (e.action == 'd') {
      let btnData = [
        { scope: 'delete', innerTxt: t('cancel'), proceed: false, class: '' },
        { scope: 'delete', innerTxt: t('confirm'), proceed: true, class: 'confirm' }
      ]
      setconfirmPopData({
        title: t('delete'),
        btnData: btnData,
        msg: t('deviceDetail.message'),
        topMsg: t('deviceDetail.deviceSelected'),
        needcheck: false,
        checktext: 'Want to delete all records?',
      })
      confirmationModalRef.current.toggleDialog();
    }
    else
      if (e.action == 'e') {
        ModifyDevicesModalRef.current.toggleDialog();

        setmodifyDevicesPopupData({
          edit: e.key,
          needcheck: false,
          checktext: 'Want to update all records?',
          updateData: [SData],
          filterData: null
        })
      }
  }



  function setTextColor(key, value) {
    if (key === 'gpsLocation') {
      return "#0073E6"
    } else {
      return deviceStatusColorMapper[value];
    }
  }


  function onChangeAction(_value) {
    setCurrentAction(_value)
    if (_value.action == 'e' || _value.action == 'd') {
      PerformEditAction(_value);
      return
    }

    let value = _value.label


    // if ( value !== 'Start finding') {
    //   setSoundPlayed(false)
    // }
    if (value === 'Start finding') {
      let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
      let value = 2;
      // let data = { deviceState: value }
      // let dataOne = { deviceStateUpdatedBy: 0 }
      // let dataToAdd = { deviceState: value, deviceStateUpdatedBy: 0 , beingFoundTimestamp:Date.now() ,deviceStateChangedAt:Date.now()}
      // DLM-23261: if it is Being Found state, then ignore 'deviceStateUpdatedBy' so that who started To Be Found will be kept either it is Auto or Manual
      let dataToAdd = { deviceState: value, beingFoundTimestamp: Date.now(), deviceStateChangedAt: Date.now() }
      if (selectedRowData?.connectionState === 'Connected') {
        addMonitor("DeviceState", dataToAdd, docId, 'START_FINDING');
        addData(dataToAdd, docId, 'deviceState');
      } else {
        // alert('Device is not connected to server')
        setInfoModalMsg(t('deviceDetail.err'));
        infoModalRef.current.open();
      }


    }

    if (value === 'Add Notes') {
      addUserModalRef.current.toggleDialog()
    }
    if (value === 'Play Sound') {
      let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;

      if (selectedRowData?.connectionState === 'Connected') {
        let value = Date.now();
        let data = { chirpStatus: value }
        addMonitor("BeepState", data, docId);
        setSoundPlayed(true);
        timer();
      } else {
        // alert('Device is not connected to server')
        setInfoModalMsg(t('deviceDetail.err'));
        infoModalRef.current.open();
      }


    }
    if (value === "Refresh Current Device's Location") {
      let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
      let value = Date.now();
      let data = { deviceState: value };
      let dataOne = { deviceStateUpdatedBy: 0 };
      let dataToAdd = { gpsState: value }

      if (selectedRowData?.connectionState === 'Connected') {
        addMonitor("DeviceGPSState", dataToAdd, docId);
        console.log(dataToAdd);
      } else {
        // alert('Device is not connected to server')
        setInfoModalMsg(t('deviceDetail.err'));
        infoModalRef.current.open();
      }


    }
    if (value === 'Mark Device for finding') {
      let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
      let value = 1;
      let data = { deviceState: value };
      let dataOne = { deviceStateUpdatedBy: 0 };
      let dataToAdd = {
        deviceState: value,
        deviceStateUpdatedBy: 0,
        tobeFoundTimestamp: Date.now(),
        deviceStateUpdateAutomationSource: ""
      }
      addMonitor("DeviceState", dataToAdd, docId);
      // addMonitor("DeviceStateUpdatedBy", dataOne, docId);
      addData(dataToAdd, docId, 'deviceState');
    }
    if (value === 'Decommission Device') {
      let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
      let data = {
        "udi": `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`,
        "action": 9999,
        "tenantId": context.currentUser.claims.companyID,
        "isDeviceCheckedOut": selectedRowData.checkOutState
      }
      sendDataToFire(data, docId)

    }
    if (value === "Recommission Device") {
      console.log(value, 'value in Recommission Device if cond.')
      let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
      let data = {
        "udi": `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`,
        "action": 0,
        "tenantId": context.currentUser.claims.companyID,
        "isDeviceCheckedOut": selectedRowData.checkOutState
      }
      sendDataToFire(data, docId);

    }

    if (value === 'Mark device as InService') {
      let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
      let value = 0;
      let data = { deviceState: value }
      let dataOne = { deviceStateUpdatedBy: 0 }
      let dataToAdd = { deviceState: value, deviceStateUpdatedBy: 0 }
      addMonitor("DeviceState", dataToAdd, docId);
      // addMonitor("DeviceStateUpdatedBy", dataOne, docId);
      addData(dataToAdd, docId, 'deviceState');
    }
  }

  // function bufferFoundEnabled() {
  //   //this is auto add data if the device stat is start finding
  //   let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
  //   let value = 0;
  //   let data = { deviceState: value }
  //   let dataOne = { deviceStateUpdatedBy: 1 }
  //   let dataToAdd = { deviceState: value, deviceStateUpdatedBy: 1 }

  //   addMonitor("DeviceState", dataToAdd, docId, 'START_FINDING_BUFFER');
  //   // addMonitor("DeviceStateUpdatedBy", dataOne, docId, 'START_FINDING_BUFFER');
  //   addData(dataToAdd, docId, 'deviceState');
  // }

  async function addMonitor(docTodb, dataTodb, docId, actionName) {
    let companyID = context.currentUser.claims.companyID;
    setIsLoading(true)
    await firestore
      .collection('tenants')
      .doc(companyID)
      .collection('Devices')
      .doc(docId)
      .collection('Monitor')
      .doc(docTodb)
      .set({ ...dataTodb }, { merge: true })

    setIsLoading(false);
    if (actionName === 'START_FINDING') {
      tbfRef.current.toggleDialog();
    }
    // if ( actionName === 'DEVICE_FOUND' && foundAutomation) {
    //     let timeleft = 1;
    //     let downloadTimer = setInterval(function () {
    //       if (timeleft <= 0) {
    //         clearInterval(downloadTimer);
    //       }
    //       let reTime = 1 - timeleft;
    //       timeleft -= 1;
    //       reTime === 1 && bufferFoundEnabled();;
    //     }, 1000);
    // }
  }

  async function sendDataToFire(finalData, docId) {
    setIsLoading(true)
    let response = await firebaseUtil.recomDecom(finalData, t);
    console.log(response, 'responseresponse')
    serverResponse.current = response;
    if(serverResponse.current.msg == DEVICELIST_CONSTANT.licenseNotAvailable){
      serverResponse.current.msg = t('messages.error.err54');
    }
    setSnackbarOpen(true);
    getData(docId);
    if (finalData.action === 0 || finalData.action === 9999) {
      addUserModalRef.current.toggleDialog();
    }
  }

  async function addData(value, docId, keyName) {
    setIsLoading(true)
    let companyID = context.currentUser.claims.companyID;
    await firestore
      .collection('tenants')
      .doc(companyID)
      .collection('Devices')
      .doc(docId)
      // .update({
      //  [keyName] : value
      // })
      .update(value)
    // setSelectedRowData(prevState => ({
    //   ...prevState,
    //   [keyName]: value
    // }))
    if (keyName == "gpsLocation") {
      serverResponse.current = { status: 'Success', msg: `${KeyNameMapper[keyName]} Requested` }

    } else {
      serverResponse.current = { status: 'Success', msg: `${KeyNameMapper[keyName]} Updated` }

    }
    setSnackbarOpen(true);
    getData(docId)


  }


  async function getData(docId) {
    console.log(docId, 'docId')
    let companyID = context.currentUser.claims.companyID;
    setIsLoading(true)
    const ref = firestore
      .collection('tenants')
      .doc(companyID)
      .collection('Devices')
      .doc(docId)

    ref.onSnapshot((querySnapshot) => {
      var items = {};
      items = querySnapshot.data();
      // console.log(items, 'mdv items')
      setCurrFireObj(items)
      setSData(querySnapshot.data())
      if (items && items?.deviceState && (String(items?.deviceState).toLowerCase() == "decommissioned") || String(items?.deviceState) == '9999') {
        setKeysToFilter(dataFor9999)
      } else {
        setKeysToFilter(dataForExcept9999)
      }
    })
  }

  function destrcutureData() {
    let exactSite = currFireObj;
    setCurrDeviceState(exactSite.deviceState);
    setCurrCheckOut(exactSite.displayUserId);
    let dataSingle = exactSite;
    dataSingle['deviceState'] = defaultReferalNum[dataSingle['deviceState']]?.deviceState
    dataSingle['isCharging'] = dataSingle?.isCharging === true ? 'Charging' : 'Not Charging';
    dataSingle['screenOn'] = dataSingle?.screenOn === true ? 'On' : 'Off';
    dataSingle['licenseState'] = dataSingle?.licenseState === 0 ? 'Unlicensed' : dataSingle?.licenseState === 1 ? 'Licensed' : '-';
    dataSingle['secondaryBleInfo'] = dataSingle?.secondaryBleInfo === 0 ? 'Not available' : dataSingle?.secondaryBleInfo === 1 ?
      'Enabled' : dataSingle?.secondaryBleInfo === 2 ? 'Disabled' : '-';
    dataSingle['connectionState'] = dataSingle?.connectionState === 0 ? 'Never Connected' : dataSingle?.connectionState === 1 ?
      'Connected' : dataSingle?.connectionState === 2 ? 'Disconnected' : '-';
    // dataSingle['batteryLevel']  
    dataSingle['gpsReportAt'] = dataSingle?.gpsReportAt ? new Date(dataSingle.gpsReportAt).toUTCString() : '-';

    dataSingle['reportedAt'] = dataSingle?.reportedAt ? new Date(dataSingle.reportedAt).toUTCString() : '-';


    setAddNoteValue(dataSingle?.note ? dataSingle.note : "")
    setaddDeviceName(dataSingle?.displayDeviceFriendlyName ? dataSingle.displayDeviceFriendlyName : "")

    dataSingle['note'] = dataSingle?.note ? dataSingle.note : "-";
    dataSingle['displayDeviceFriendlyName'] = dataSingle?.displayDeviceFriendlyName ? dataSingle.displayDeviceFriendlyName : '-';
    dataSingle['displaySiteName'] = dataSingle?.displaySiteName ? dataSingle.displaySiteName : "-";

    let batteryLevel = dataSingle['batteryLevel'];
    let batteryText = () => {
      let displayBatteryLevel = "";

      if (batteryLevel <= 15) {
        return displayBatteryLevel = `Low at ${batteryLevel}%`;
      }
      if (batteryLevel > 15 && batteryLevel <= 66) {
        return displayBatteryLevel = `Medium at ${batteryLevel}%`
      }
      if (batteryLevel > 66) {
        return displayBatteryLevel = `High at ${batteryLevel}%`
      }
      return displayBatteryLevel
    }
    let enrollOn = () => {
      if (typeof undefined != typeof dataSingle.lastEnrolOn &&
        typeof undefined != typeof dataSingle.dlrEnrolStatus &&
        dataSingle.dlrEnrolStatus == DLR_MACHINE_LEARNING.ENROLL_STATUS_VALUES.ENROLLED) {
        return (convertUtcToTimeZone(dataSingle.lastEnrolOn, dataSingle?.siteTimeZone))
      }
      else {
        return ("-")
      }
    }

    let dlrEnrolStatus = () => {
      if (typeof undefined != typeof dataSingle.dlrEnrolStatus) {
        return (DLR_MACHINE_LEARNING.DLR_ENROLL_STATUS[dataSingle.dlrEnrolStatus])
      }
      else {
        return ('-')
      }
    }

    let dlrIssue = () => {
      console.log(dataSingle.dlrIssue);
      if (typeof undefined != typeof dataSingle.dlrIssue) {
        return (DLR_MACHINE_LEARNING.DLR_ISSUE[dataSingle.dlrIssue])
      }
      else {
        return ("-")
      }
    }

    if (typeof undefined != typeof dataSingle.dlrEnrolStatus) {
      if (Number(dataSingle.dlrEnrolStatus) == DLR_MACHINE_LEARNING.ENROLL_STATUS_VALUES.ENROLLED) {
        dataSingle['lastEnrolOn'] = enrollOn();
        dataSingle['dlrIssue'] = dlrIssue();
      }
      else {
        delete dataSingle['lastEnrolOn']
        delete dataSingle['dlrIssue']
      }
      dataSingle['dlrEnrolStatus'] = dlrEnrolStatus();
    }
    else {
      delete dataSingle['dlrEnrolStatus']
      delete dataSingle['lastEnrolOn']
      delete dataSingle['dlrIssue']
    }

    if (globalAppSettings.enableBTScannerTracking) {
      let btScannerData = dataSingle.btscanner;
      if (btScannerData?.licenseState === 1) {
        dataSingle["btscanner"] = btScannerData?.scannerID;
        setBTScannerState(btScannerData?.state);
      } else {
        dataSingle["btscanner"] = "-";
        setBTScannerState(0);
      }
    } else {
      delete dataSingle['btscanner'];
    }
    setNote(dataSingle?.note ? dataSingle.note : "")

    let newStructure = {}
    keysToFilter.forEach(bb => {
      return Object.keys(dataSingle).forEach(ab => {
        if (bb === ab) {
          if (ab == 'apFriendlyName' && !dataSingle[ab]) {
            return newStructure[ab] = dataSingle['apMacAddress']
          }
          return newStructure[ab] = dataSingle[ab]
        }
        // if(ab == 'apFriendlyName' && !dataSingle[ab] ){return newStructure[ab] =dataSingle['apMacAddress']}

        return
      })
    })

    setSelectedRowData(newStructure)
    setIsLoading(false)
  }

  async function findingBtnClick(value) {
    if (value === 'Stop Finding') {
      let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
      let value = 1;
      let data = { deviceState: value }
      let dataOne = { deviceStateUpdatedBy: 0 }
      // let dataToAdd = { deviceState: value, deviceStateUpdatedBy: 0, tobeFoundTimestamp: Date.now() }
      // DLM-23261: if it is Being Found state, then ignore 'deviceStateUpdatedBy' so that who started To Be Found will be kept either it is Auto or Manual
      let dataToAdd = { deviceState: value, tobeFoundTimestamp: Date.now() }

      setCurrentAction("")
      addData(dataToAdd, docId, 'deviceState');
      addMonitor("DeviceState", dataToAdd, docId);
      // addMonitor("DeviceStateUpdatedBy", dataOne, docId);
    }
    if (value === 'Play Sound') {
      let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
      let value = Date.now();
      let data = { chirpStatus: value }
      addMonitor("BeepState", data, docId);
      setSoundPlayed(true);
      timer();
    }
    if (value === 'Cannot Find') {
      let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
      let value = 4;
      let data = { deviceState: value, deviceStateUpdatedBy: 0 }
      let dataToAdd = { deviceState: value, deviceStateUpdatedBy: 0 }
      setCurrentAction("")
      addData(data, docId, 'deviceState');
      addMonitor("DeviceState", dataToAdd, docId, 'CANNOT_FIND');
      tbfRef.current.toggleDialog()

    }
    if (value === 'Device Found') {
      try {
        setCurrentAction("")

        let docId = `${selectedRowData.modelNumber}_${selectedRowData.serialNumber}`;
        let value = 3;
        let dataToAdd = { deviceState: value, deviceStateUpdatedBy: 0, foundTimestamp: Date.now() }
        addMonitor("DeviceState", dataToAdd, docId, 'DEVICE_FOUND')
        await addData(dataToAdd, docId, 'deviceState').then(() => {
          tbfRef.current.toggleDialog()
          let companyID = context.currentUser.claims.companyID;
          const settingsRef = firestore
            .collection('tenants')
            .doc(companyID)
            .collection('Configuration')
            .doc('AppSettings')

          settingsRef.onSnapshot((querySnapshot) => {
            var items = {};
            items = querySnapshot.data();
            if (items.enableFoundAutomation) {
              updateDeviceState();
            }
          })
        })
      }
      catch (err) {
        console.log("Error while marking device as Found ", JSON.stringify(err))
      }
    }
  }

  function timer() {
    let timeleft = 7;
    let downloadTimer = setInterval(function () {
      if (timeleft <= 0) {
        clearInterval(downloadTimer);
      }
      let reTime = 7 - timeleft;
      timeleft -= 1;
      reTime === 7 && setSoundPlayed(false);
    }, 1000);
  }

  const isManager = context.currentUser.claims.isManager;

  //Manager chagnes
  var actionMenus = [];

  actionMenus.push({ label: 'Edit', disable: false, header: true });

  if (!isManager) {
    //Update site is availabe only for ADMIN
    actionMenus.push({ label: 'Delete Device', key: 'delete', disable: false, action: 'd' });
  }


  //Other Menus
  actionMenus.push({ label: 'Tracking', disable: false, header: true });
  actionMenus.push({ label: "Refresh Current Device's Location", disable: false, action: 't' });
  actionMenus.push({ label: 'Mark Device for finding', disable: false, action: 't' });
  actionMenus.push({ label: 'Mark device as InService', disable: false, action: 't' });
  actionMenus.push({ label: 'Play Sound', disable: false, action: 't' });
  actionMenus.push({ label: 'Add Notes', disable: false, action: 't' });
  actionMenus.push({ label: 'Recommission Device', disable: false, action: 't' });
  actionMenus.push({ label: 'Decommission Device', disable: false, action: 't' });



  const handleNotesFiledChange = (e) => {
    console.log(e.target.value, addNoteValue, note)
    setAddNoteValue(e.target.value)
    setNote(e.target.value)
    if (e.key === 'Enter') {
      handleSaveNotes(e)
    }
  }
  const handleDeviceNameChange = (e) => {
    let inputValue = e.target.value
    if (inputValue !== '' && inputValue.length > 32) {
      deviceNameSetError(true);
    } else {
      deviceNameSetError(false);
      setaddDeviceName(e.target.value)
      if (e.key === 'Enter') {
        handleSaveDeviceName(e)
      }

    }
  }
  const handleSaveNotes = (e) => {

    if (SData.note !== e.target.value) {
      getAddedNote(e.target.value);
    }
    //console.log("hello updated",e.target.value , addNoteValue , note ,SData)
  }
  const handleSaveDeviceName = (e) => {
    //console.log("hello",e.target.value , addNoteValue , note ,SData)
    if (SData.friendlyName !== e.target.value && SData.displayDeviceFriendlyName !== e.target.value) {
      getAddedDeviceName(e.target.value);
    }
  }

  const getDeviceDetails = (key, value) => {
    if (key == "note") {
      return (<TextField id="outlined-basic" variant="outlined" size='small' value={addNoteValue} onChange={handleNotesFiledChange} onBlur={handleSaveNotes} onKeyDown={handleNotesFiledChange} />)
    }
    else if (key == "btscanner") {
      console.log("btscannerState ", btscannerState);
      return (<><font style={{ color: accessoryStateColorMap[btscannerState] }}>{value}</font>
      </>
      )
    }
    else if (key == "friendlyName") {
      if (!isManager || (globalAppSettings?.userRoleSettings?.manager?.Devices
        && globalAppSettings?.userRoleSettings?.manager?.Devices[0] === 'update')) {
        return (<TextField id="outlined-basic" variant="outlined" size='small' style={{ maxWidth: "220PX" }} value={addDeviceName} onChange={handleDeviceNameChange} onBlur={handleSaveDeviceName} error={deviceNameError} onKeyDown={handleDeviceNameChange} helperText={deviceNameError ? t('validation.rules.Mo_Dash.DeFrNa32Len') : ''} />)
      } else {
        return value ? value : "-";
      }
    } else if (key == "displaySiteName") {
      if (!isManager && (globalAppSettings?.deviceRegistrationType == null || globalAppSettings?.deviceRegistrationType == 0)) {
        return (
          <>
            {value ? value : "-"}
            <EditIcon style={{ color: '#0073E6', cursor: 'pointer' }} fontSize='small' onClick={(e) => {
              ModifyDevicesModalRef.current.toggleDialog();
              setmodifyDevicesPopupData({
                edit: "edit_site",
                needcheck: false,
                checktext: 'Want to update all records?',
                updateData: [SData],
                filterData: null
              })
            }} />
          </>
        )
      }
      else {
        return value ? value : "-";
      }
    } else if (key == "reportedAt") {
      return convertUtcToTimeZone(value, selectedRowData?.siteTimeZone)
    }
    else {
      if (key === "gpsLocation") {
        return (
          <p><LocationIcon style={{ color: '#0073E6' }} /><LocationSpan>{value}</LocationSpan></p>
        )
      }
      else
        return value ? value : "-";
    }
  }


  return (
    <PageWrapper style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1', position: 'relative', zIndex: '99' }}>
      {isLoading && <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
        <CircularProgress />
      </div>}
      <BacknTitle>
        <GoBack />
        <PageTitle>{t('deviceDetails')}</PageTitle>
      </BacknTitle>
      {/* <div className='device-details-button-row'>
        <DropdownActions
          label={'Actions'}
          opts={actionVal}
          onChangeAction={onChangeAction} deviceStatus={selectedRowStatus} style={{ 'margin-bottom': '1%' }} />
      </div> */}
      <div style={{ width: '130px' }}>
        <ActionDropDown
          label={t('action')}
          disable={false}
          selectedRows={1}
          options={
            actionVal
          }
          hideClrData={true}
          hideselectedCount={true}
          GetChangeAction={onChangeAction}
          clrSelectedRows={() => { }}
        />
      </div>
      <DetailsCard>
        {Object.keys(selectedRowData).length > 0 && Object.entries(selectedRowData).map((obj, idx) => {
          for (let index = 0; index < keysToFilter.length; index++) {
            if (keysToFilter[index] === obj[0] && keysToFilter[index] != "siteTimeZone") {
              return <Grid container spacing={2}>
                {
                  Object.keys(obj).map((key, i) => (
                    <Grid item xs={i === 0 ? 4 : 6} >
                      {i === 0 ? <KeyNameBold>{KeyNameMapper[obj[key]]} </KeyNameBold> : obj[key] !== null ?
                        <span onClick={obj[0] === 'gpsLocation' ? () => launchMap(obj[key], t('gps.coordinate_error')) : undefined}
                          style={{
                            color: `${setTextColor(obj[0], obj[key])}`,
                            fontWeight: `${obj[0] === 'deviceState' ? 'bold' : 'none'}`,
                            cursor: `${obj[0] === 'gpsLocation' ? 'pointer' : 'unset'}`,
                            textDecorationLine: `${obj[0] === 'gpsLocation' ? 'underline' : 'none'}`
                          }}>{getDeviceDetails(obj[0], obj[key])}
                        </span>
                        : '-'}
                    </Grid>
                  ))}
                <Grid item xs={6}>
                  <Paper></Paper>
                </Grid>
              </Grid>
            }
          }
        }
        )
        }
      </DetailsCard>
      <AddNoteModal
        modalRef={addUserModalRef}
        getAddedNote={getAddedNote}
        clearNote={clearNote}
        noteValue={note}
      // onClose={() => onModalClose('add user')} 
      />
      <InfoModal modalRef={infoModalRef} msg={infoModalMsg} />

      <ChangeActionTbf
        modalRef={tbfRef}
        selectedRowData={selectedRowData}
        keysToFilter={keysToFilter}
        KeyNameMapper={KeyNameMapper}
        closeClicked={() => findingBtnClick('Stop Finding')}
        currentAction={currentAction}
        findingBtnClick={findingBtnClick}
        soundPlayed={soundPlayed}
        deviceStatusColorMapper={deviceStatusColorMapper}
      />


      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
      >
        <SnackbarContent error={serverResponse.current.status ? false : true}>
          {serverResponse.current.msg}
        </SnackbarContent>

      </Snackbar>
      {soundPlayed &&
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          style={{
            zIndex: 9999
          }}
          open={true}
          autoHideDuration={6000}
          //   onClose={handleClose}
          message="Play sound has been requested"
        // action={
        //   <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
        //   <CloseIcon fontSize="small" />
        // </IconButton>
        // }
        />
      }
      <ModifyDevicesPopUp
        modalRef={ModifyDevicesModalRef}
        PopupData={modifyDevicesPopupData}
        popUpTrigger={AddModiDeletePopUpTrigger}
      />
      <ConfirmationModal
        title={confirmPopData.title}
        body={confirmPopData.msg}
        modalRef={confirmationModalRef}
        btnData={confirmPopData.btnData}
        topMsg={confirmPopData.topMsg}
        needcheck={confirmPopData.needcheck}
        checktext={confirmPopData.checktext}
        fromConfirmationPopup={fromConfirmationPopup}
      />
    </PageWrapper>
  )
}

export default DeviceDetails;